import React, { Component } from 'react';
import * as debounce from 'lodash.debounce';
import { connect } from 'react-redux';
import OrganizationSearch from '../Components/OrganizationSearch';
import { query, setSearchQuery, selectOrganization } from '../Actions/OrganizationSearch.action';

class OrganizationSearchContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {...props};
    }

    render() {
        return (
            <div ref={(elem) => this.searchContainer = elem} >
                <OrganizationSearch {...{...this.props }} />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        query: state.organizationSearch.query,
        result: state.organizationSearch.result,
        showResult: state.organizationSearch.showResult,
        selectedItem: state.organizationSearch.selectedItem,
        redirectUrl: state.organizationSearch.redirectUrl,
    }
}

// debouncing function to 200ms so we don't send query request on every key stroke
const debouncedQuery = debounce((dispatch, text) => dispatch(query(text)), 200);

const mapDispatchToProps = dispatch => {
    return {
        onSearch: (text) => {
            dispatch(setSearchQuery(text));
            debouncedQuery(dispatch, text);
        },
        setSearchQuery: (text) => dispatch(setSearchQuery(text)),
        selectOrganization: (organization, redirectUrl) => dispatch(selectOrganization(organization, redirectUrl)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationSearchContainer);
